export default __webpack_public_path__ + "static/media/iwebdesignauckland.cd820f6b.png";